<template>
        <div class="screen-tags" @click="screenTags">
            <span v-if="!screen_tags_text">筛选标签</span>
            <div v-else class="screen-tags-text" >
                {{screen_tags_text}}
            </div>
            <Icon v-if="screen_tags_text" @click.stop="cleanTags" size="20" class="screen-tags-icon"  type="ios-close-circle" />
            <Tags :customer_id="customer_id" :show_tags="show_label" :tags_active="tags_active" :is_return="tags_return" @return_data="get_select_tags" @hide_lable="hide_label_func"></Tags>

        </div>

</template>
<script>
    import { Tags} from "@/components/mainLayout"
    export default {
        components:{
            Tags
        },
        data(){
            return{
                customer_id:0,
                show_label:false,
                tags_active:[],
                screen_tags_list:[],
                screen_tags_active:[],
                screen_tags_text:"",
                tags_return:false,
                screen_tags_active_id:""
            }
        },
        methods:{

            hide_label_func(e){
                this.show_label = false
                if (e == 1) {
                    this.getList()
                }
            },
            screenTags(){
                this.tags_return = true;
                this.show_label = true
                if (this.screen_tags_text != "'") {
                    this.tags_active = this.screen_tags_active
                }
            },
            get_select_tags(e){
                this.show_label = false;
                this.screen_tags_list = e;
                this.screen_tags_active = ""
                this.screen_tags_text = ""
                this.screen_tags_active_id = ""
                if (this.screen_tags_list) {
                    this.tags_active = [];
                    let screen_tags = [];
                    let screen_tags_active_id = [];
                    for(let i in this.screen_tags_list) {
                        this.tags_active.push(this.screen_tags_list[i].tag_id+"，"+this.screen_tags_list[i].tag_name)
                        screen_tags.push(this.screen_tags_list[i].tag_name)
                        screen_tags_active_id.push(this.screen_tags_list[i].tag_id)
                    }
                    this.screen_tags_active = this.tags_active
                    this.screen_tags_text = screen_tags.join(",")
                    this.screen_tags_active_id = screen_tags_active_id.join(",")
                }
                this.$emit("changeTags", this.screen_tags_text)
                this.$emit("changeTagsId", this.screen_tags_active_id)
            },
            cleanTags(){
                this.screen_tags_active = []
                this.screen_tags_text = ""
                this.screen_tags_active_id = "";
                this.$emit("changeTags", this.screen_tags_text)
                this.$emit("changeTagsId", this.screen_tags_active_id)
            }
        }
    }
</script>
<style scoped>
    .screen-tags{
        border:1px solid #dcdee2;
        width:240px; height:30px;
        display:inline-block;
        position: relative;
        vertical-align: middle;
        line-height: normal;
        border-radius: 4px;
        margin-left:10px;
        padding:4px;
        cursor: pointer;
        color:#c8ccd5;
    }
    .screen-tags-text{
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
        color:#000000;
        width:235px;
    }
    .screen-tags-icon{
        position: absolute;
        top: -11px;right: 1px;
        color: #3F8CFF;
    }
    .screen-tags-icon:hover{
        color:#0c4cad
    }
</style>
